import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './montana-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-montana',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    CommonModule,
    JsonPipe,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './montana.component.html',
})
export class MontanaComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('montana', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('montana', null);
    }
  }
}
